"use client";
import { motion } from "motion/react";
import Link from "next/link";
import { ExternalLink, ArrowRight } from "lucide-react";

interface Attraction {
  AttractionURL: string;
  Title: string;
  TagLine: string;
}

interface AttractionsSectionProps {
  attractions: Attraction[];
}

export default function AttractionsSection({
  attractions,
}: AttractionsSectionProps) {
  if (!attractions || attractions.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
      {attractions.map((place, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          viewport={{ once: true }}
        >
          {place?.AttractionURL ? (
            <Link
              href={`/attraction/${place?.AttractionURL || ""}/`}
              className="block group"
            >
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 h-full">
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-2xl text-white mb-3 group-hover:text-[#C9A962] transition-colors">
                    {place?.Title}
                  </h3>
                  <ExternalLink className="h-5 w-5 text-[#C9A962] opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <p className="text-white/70 leading-relaxed">
                  {place?.TagLine}
                </p>
                <div className="mt-6 flex items-center text-[#C9A962] group-hover:translate-x-2 transition-transform">
                  <span className="text-sm tracking-wider">EXPLORE</span>
                  <ArrowRight className="h-4 w-4 ml-2" />
                </div>
              </div>
            </Link>
          ) : (
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 h-full">
              <h3 className="text-2xl text-white mb-3">{place?.Title}</h3>
              <p className="text-white/70 leading-relaxed">{place?.TagLine}</p>
            </div>
          )}
        </motion.div>
      ))}
    </div>
  );
}
